<template>
  <section class="hk-breadth">
    <TitleHeader title="今日股市" />
    <div class="breadth-body" v-loading="loading" element-loading-background="var(--theme-bg)">
      <div class="distribution">
        <div v-for="(item, index) in diagram" :key="index" class="distribution-item">
          <b :style="{ color: barColor(item, index) }">{{ item.count }}</b>
          <span class="bar" :style="{ height: barHeight(item.count), background: barColor(item, index) }"></span>
          <small>{{ item.title }}</small>
        </div>
        <div v-if="!diagram.length" class="empty">暂无市场分布数据</div>
      </div>
      <div class="market-count"><span>涨：{{ ratio.up || 0 }}</span><span>平：{{ ratio.balance || 0 }}</span><span>跌：{{ ratio.down || 0 }}</span></div>
      <div class="market-ratio">
        <span v-for="key in ['up', 'balance', 'down']" :key="key" :class="key" :style="{ width: `${ratioWidth(key)}%` }"></span>
      </div>
      <div v-if="total" class="market-comment">当前市场上涨家数占比全市场{{ Math.round(ratioWidth('up')) }}%</div>
    </div>
  </section>
</template>

<script>
import TitleHeader from '../../home/components/titleHeader.vue'

export default {
  name: 'HongKongMarketBreadth',
  components: { TitleHeader },
  props: {
    loading: { type: Boolean, default: false },
    diagram: { type: Array, default: () => [] },
    ratio: { type: Object, default: () => ({}) }
  },
  computed: {
    total() { return ['up', 'balance', 'down'].reduce((sum, key) => sum + Number(this.ratio[key] || 0), 0) }
  },
  methods: {
    ratioWidth(key) { return this.total ? Number(this.ratio[key] || 0) / this.total * 100 : 0 },
    barHeight(value) {
      const maximum = Math.max(...this.diagram.map(item => Number(item.count || 0)), 1)
      return `${Number(value || 0) / maximum * 70}%`
    },
    barColor(item, index) {
      const middle = Math.floor(this.diagram.length / 2)
      if (item.status === 'up') return 'var(--quote-up)'
      if (item.status === 'down') return 'var(--quote-down)'
      return index < middle ? 'var(--quote-up)' : index === middle ? 'var(--theme-muted)' : 'var(--quote-down)'
    }
  }
}
</script>

<style scoped>
.hk-breadth { background: var(--theme-bg); color: var(--theme-text); min-width: 0; }
.breadth-body { display: flex; flex-direction: column; height: calc(38.6vh - 36px); padding: 0 23px; }
.distribution { display: flex; flex: 1; min-height: 0; align-items: flex-end; justify-content: space-around; padding: 22px 0; }
.distribution-item { display: flex; flex: 1; min-width: 0; height: 100%; flex-direction: column; align-items: center; justify-content: flex-end; }
.distribution-item b { margin-bottom: 5px; color: #009688; font-size: 12px; font-weight: normal; }
.distribution-item small { height: 20px; margin-top: 6px; color: #6e7079; font-size: 11px; white-space: nowrap; }
.bar { width: 40%; max-width: 22px; }
.market-count { display: flex; justify-content: space-around; margin: 4px 0 6px; }
.market-ratio { display: flex; flex-shrink: 0; height: 10px; overflow: hidden; border-radius: 2px; }
.up { background: var(--quote-up); } .balance { background: var(--theme-muted); } .down { background: var(--quote-down); }
.market-comment { padding: 10px 0; text-align: center; }
.empty { width: 100%; color: var(--theme-muted); text-align: center; }
</style>
